'use strict';
import React from 'react';
import attdAction from '../../actions/attdAction';
import AttdModal from './attdModal';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';
import { METHODS } from 'http';

class AllList extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.showOption = this.showOption.bind(this);
        this.closeOption = this.closeOption.bind(this);
        this.handleOption = this.handleOption.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.updateAttandance = this.updateAttandance.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            staffId: "",
            year: "",
            month: "",
            date: "",
            modalClose: false,
            title: "Edit Time in / Time Out",
            timeIn: "",
            timeOut: "",
            dateTxt: "",
            startRemark: "",
            endRemark: "",

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        };
    }
    componentDidMount() {
        userStore.listen(this.onChange);
        window.addEventListener("click", this.closeOption);
    }
    componentWillUnmount() {
        userStore.unlisten(this.onChange);
        window.removeEventListener("click", this.closeOption);
    }
    onChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    static defaultProps = {
        mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
        durationTxt: ["Full", "Am", "Pm"]
    }
    handleOption(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let staffId = e.currentTarget.getAttribute("data-staffid");
        let _id = e.currentTarget.getAttribute("data-id");
        let year = e.currentTarget.getAttribute("data-year");
        let month = e.currentTarget.getAttribute("data-month");
        let date = e.currentTarget.getAttribute("data-date");
        let timeIn = e.currentTarget.getAttribute("data-timein");
        let timeOut = e.currentTarget.getAttribute("data-timeout");
        let dateTxt = e.currentTarget.getAttribute("data-datetxt");
        let startRemark = e.currentTarget.getAttribute("data-startremark");
        let endRemark = e.currentTarget.getAttribute("data-endremark");
        this.setState({
            _id: _id,
            staffId: staffId,
            year: year,
            month: month,
            date: date,
            timeIn: timeIn,
            timeOut: timeOut,
            dateTxt: dateTxt,
            startRemark: startRemark,
            endRemark: endRemark,
            modalClose: true
        });

        attdAction.shouldDDListShow({ index: index, useFor: this.props.useFor, staffId: staffId });
    }

    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        index = index + this.props.page * this.props.contentNo;
        attdAction.shouldListShow({ index: index, useFor: this.props.useFor });
    }
    updateAttandance(timeIn, timeOut, startRemark, endRemark) {
        if (this.props.processing) return;
        let startTime, endTime;
        if (timeIn) {
            startTime = new Date(this.state.year, this.state.month, this.state.date, timeIn.split(":")[0], timeIn.split(":")[1]).getTime();
        }
        if (timeOut) {
            endTime = new Date(this.state.year, this.state.month, this.state.date, timeOut.split(":")[0], timeOut.split(":")[1]).getTime();
        }
        this.setState({ modalClose: false });
        attdAction.processing(true);
        attdAction.updateAttandance(this.state._id, this.state.staffId, this.state.year, this.state.month, this.state.date, startTime, endTime, startRemark, endRemark);
    }
    shouldModalClose() {
        this.setState({
            modalClose: false
        });
    }
    renderNameList(staff, index) {
        return (
            <div className="atd-a-nlw" style={{ width: this.props.tableWidth + "px" }}>
                <i className={"atd-a-nli " + (staff.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus")}
                    onClick={this.handleClick} data-index={index}></i>
                <div className="atd-a-nl atd-a-n" onClick={this.handleClick} data-index={index}>{staff.userName}</div>
            </div>
        );
    }
    renderDataList(staff) {
        if (!staff.attendance) return;

        let dateList = staff.attendance.map((attendance, index) => {
            let display1 = "--", display2 = "--", display3 = "--", display4 = "--", display5 = "--";
            let dateTxt = attendance.date + "-" + this.props.mthTxt[attendance.month] + "-" + attendance.year;

            if (typeof attendance.type == 'number') {
                if (attendance.type != 7) {
                    display3 = attendance.leaveTxt + " (" + this.props.durationTxt[attendance.duration] + ")";
                } else {
                    display3 = attendance.leaveTxt + " (" + (attendance.startTime ? attendance.startTime + "~" : "-") +
                        (attendance.endTime ? attendance.endTime : "-") + ")";
                }
            } else {
                display3 = "--";
                if (attendance.startTime) {
                    attendance.startTime = new Date(attendance.startTime);
                    let timeInHour = (attendance.startTime.getHours() < 10 ? "0" + attendance.startTime.getHours() : attendance.startTime.getHours());
                    let timeInMinute = (attendance.startTime.getMinutes() < 10 ? "0" + attendance.startTime.getMinutes() : attendance.startTime.getMinutes());
                    display1 = timeInHour + ":" + timeInMinute;
                    display4 = attendance.startRemark ? attendance.startRemark : "--";
                } else {
                    display1 = "--";
                    attendance.startLocation = "--";
                    display4 = "--";
                }
                if (attendance.endTime) {
                    attendance.endTime = new Date(attendance.endTime);
                    let timeOutHour = (attendance.endTime.getHours() < 10 ? "0" + attendance.endTime.getHours() : attendance.endTime.getHours());
                    let timeOutMinute = (attendance.endTime.getMinutes() < 10 ? "0" + attendance.endTime.getMinutes() : attendance.endTime.getMinutes());
                    display2 = timeOutHour + ":" + timeOutMinute;
                    display5 = attendance.endRemark ? attendance.endRemark : "--";
                } else {
                    display2 = "--";
                    attendance.endLocation = "--";
                    display5 = "--";
                }
            }



            return (

                <tr key={index}>
                    <td>{staff.staffId}</td>
                    <td>{staff.userName}</td>
                    <td>{dateTxt}</td>
                    <td>{display1}</td>
                    <td>{attendance.startLocation}</td>
                    <td>{display4}</td>
                    <td>{display2}</td>
                    <td>{attendance.endLocation}</td>
                    <td>{display5}</td>
                    <td>{display3}</td>
                    <td>{attendance.totalHours ? Math.round(attendance.totalHours * 100) / 100 : "--"}</td>
                    <td>{attendance.otHours ? Math.round(attendance.otHours * 100) / 100 : "--"}</td>
                    <td>
                        {
                            ((genFunction.hasPermission(this.state.permission, 0) && !genFunction.isUser(this.state.userId, staff.staffId)) ||
                                genFunction.isSubordinate(this.state.subordinate, attendance.staffId)
                            ) &&
                                typeof attendance.type != 'number' ?
                                <span className="atd-edit glyphicon glyphicon-option-vertical" data-index={index} data-id={staff.staffId} onClick={this.showOption}></span>
                                : ""
                        }
                        {this.renderEdit(index, staff, attendance, display1, display2, dateTxt, attendance.startRemark, attendance.endRemark)}
                    </td>
                </tr>
            )
        });

        return (
            <table className="atd-a-tb">
                <tbody className={"atd-a-tb " + (staff.shouldListShow ? "atd-show" : "atd-hide")}>
                    {dateList}
                </tbody>
            </table>
        );
    }
    showOption(e) {
        e.preventDefault();
        e.stopPropagation();

        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        //index = index + this.props.page * this.props.contentNo;
        let staffId = e.currentTarget.getAttribute("data-id");
        attdAction.shouldDDListShow({ index: index, useFor: this.props.useFor, staffId: staffId });
    }
    closeOption() {
        attdAction.closeListShow();
    }
    renderEdit(index, staff, attendance, timeIn, timeOut, dateTxt, startRemark, endRemark) {
        if (!genFunction.hasPermission(this.state.permission, 0) && !genFunction.isSubordinate(this.state.subordinate, attendance.staffId)) return;
        if (genFunction.isUser(this.state.userId, staff.staffId)) return;
        if (typeof attendance.type == 'number') return;

        return (
            <ul className={"atd-dropdown " + (attendance.shouldDDListShow ? "atd-show" : "atd-hide")} >
                <li data-staffid={staff.staffId} data-id={attendance._id}
                    data-year={attendance.year} data-month={attendance.month}
                    data-timein={timeIn} data-timeout={timeOut} data-startremark={startRemark} data-endremark={endRemark}
                    data-date={attendance.date} data-index={index} data-datetxt={dateTxt}
                    onClick={this.handleOption}>Edit attendance</li>
            </ul>
        );
    }
    renderTotalHour(staff) {
        return (
            <div className={"atd-th " + (staff.shouldListShow ? "atd-show" : "atd-hide")} style={{ width: this.props.tableWidth + "px" }}>
                <div className="atd-th-tt">Total Hours Spent On Locations: {staff.totalHours ? Math.floor(staff.totalHours) : "-"} hours</div>
                <div className="atd-th-ct">{staff.totalHours ? Math.round((staff.totalHours - Math.floor(staff.totalHours)) * 60) + " minutes" : ""}</div>
            </div>
        );
    }
    renderMainList() {
        if (this.props.staffsAtd.length > 0 && this.props.staffsAtd[0]) {
            return this.props.staffsAtd.map((staff, index) => {
                return (
                    <div key={index}>
                        {this.renderNameList(staff, index)}
                        {this.renderDataList(staff)}
                        {this.renderTotalHour(staff)}
                    </div>
                );
            });
        }
    }

    render() {
        let modal = "";
        if (this.state.modalClose) {
            modal = (
                <AttdModal modalClose={this.state.modalClose} shouldModalClose={this.shouldModalClose} startRemark={this.state.startRemark}
                    title={this.state.title} dateTxt={this.state.dateTxt} endRemark={this.state.endRemark}
                    callBack={this.updateAttandance} timeIn={this.state.timeIn} timeOut={this.state.timeOut} />
            );
        }
        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    {this.renderMainList()}
                </div>
                {modal}
            </div>
        );
    }
}
export default AllList;


// WEBPACK FOOTER //
// ./app/components/attdComponents/allList.js